module.exports = __webpack_public_path__ + "img/case-浙江大学.a5c58735.png";